import { Icon, IconProps } from '../Icon'

export const ArrowBackIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      arrow_back
    </Icon>
  )
}
